if (!customElements.get('pawday-offers')) {
 customElements.define('pawday-offers', class extends HTMLElement {
  connectedCallback() {
   if(this.ready)return; this.ready=true;
   this.classList.add('is-ready');
   this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.dataset.currency || 'USD'}).format(value/100);
   this.querySelectorAll('.pd-deal-sizes select').forEach(select=>{
    const label=select.labels[0],group=document.createElement('div');
    group.className='pd-size-buttons';group.setAttribute('role','group');
    group.setAttribute('aria-label',label.textContent.trim());
    const order=['XS','S','M','L','XL','XXL','XXXL'];
    [...select.options].sort((a,b)=>order.indexOf(a.textContent.trim().split(' ')[0])-order.indexOf(b.textContent.trim().split(' ')[0])).forEach(option=>{
     const button=document.createElement('button');
     button.type='button';button.className='pd-size-button';button.textContent=option.textContent.trim();
     button.dataset.variant=option.value;button.disabled=option.disabled;
     button.setAttribute('aria-pressed',String(option.selected));
     button.addEventListener('click',()=>{
      select.value=option.value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
     });
     group.append(button);
    });
    select.after(group);select.hidden=true;
    label.removeAttribute('for');
   });
   this.addEventListener('change',event=>{
    if(event.target.type==='radio')this.querySelectorAll('.pd-deal-card').forEach(card=>card.classList.toggle('is-selected',card.contains(event.target)));
    this.update();
   });
   this.addEventListener('submit',event=>this.add(event));
   this.update();
  }
  update(){
   this.querySelectorAll('.pd-deal-sizes select').forEach(select=>{
    select.nextElementSibling.querySelectorAll('.pd-size-button').forEach(button=>{
     button.setAttribute('aria-pressed',String(button.dataset.variant===select.value));
    });
   });
   this.querySelectorAll('.pd-deal-card').forEach(card=>{
    const options=[...card.querySelectorAll('select')].map(s=>s.selectedOptions[0]);
    const groups=new Map();
    options.forEach(o=>{if(o)groups.set(o.value,(groups.get(o.value)||0)+Number(o.dataset.price));});
    const rate=Number(card.dataset.rate);
    const regular=[...groups.values()].reduce((a,b)=>a+b,0);
    const saved=options.reduce((sum,o)=>sum+Math.floor(Number(o.dataset.price)*rate/100),0);
    card.querySelector('[data-offer-total]').textContent=this.money(regular-saved);
    card.querySelector('[data-offer-regular]').textContent=this.money(regular);
    card.querySelector('[data-offer-saving]').textContent=`Save ${this.money(saved)} at checkout`;
    const low=options.some(o=>o && Number(o.dataset.stock)>0 && Number(o.dataset.stock)<=100);
    const notice=card.querySelector('[data-offer-stock]'); notice.hidden=!low;notice.textContent=low?'Low stock in your selected size':'';
    card.querySelector('button[type=submit]').disabled=options.some(o=>!o||o.disabled);
   });
  }
  async add(event){
   event.preventDefault(); const form=event.target,button=form.querySelector('button[type=submit]'),error=form.querySelector('.pd-deal-error');
   const items=[...form.querySelectorAll('select')].map(s=>({id:s.value,quantity:1}));
   error.hidden=true;button.disabled=true;button.setAttribute('aria-busy','true');
   try{
    const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json();
    if(!response.ok)throw new Error(data.description||'Could not add these sizes. Please try again.');
    location.assign(this.dataset.cartUrl);
   }catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');}
  }
 });
}
